import '@styles/webdesktop/stylesheets/link.scss';
import React from 'react';
import { TypographyLevel } from '../Typography/TypographyLevel';
import { Typography } from '../Typography/Typography';
export const Link = ({ text, href }) => {
    return (React.createElement("a", { className: "link", href: href, target: "_blank", rel: "noopener noreferrer" },
        React.createElement(Typography, { level: TypographyLevel.BodySm }, text)));
};
